// extracted by mini-css-extract-plugin
export var button = "styles-module--button--0f9de";
export var response = "styles-module--response--39b70";
export var separator = "styles-module--separator--60819";